// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Thin overlay scrollbar: no track, inset pill, quiet until hover. */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(148, 163, 184, 0.4) transparent;
}

.custom-scrollbar:hover {
  scrollbar-color: rgba(100, 116, 139, 0.65) transparent;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(148, 163, 184, 0.35);
  border: 3px solid transparent;
  border-radius: 999px;
  background-clip: padding-box;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background-color: rgba(100, 116, 139, 0.6);
}

.custom-scrollbar::-webkit-scrollbar-corner {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/styles/scrollbar.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;EACE,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,6BAA6B;EAC7B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* Thin overlay scrollbar: no track, inset pill, quiet until hover. */\n.custom-scrollbar {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(148, 163, 184, 0.4) transparent;\n}\n\n.custom-scrollbar:hover {\n  scrollbar-color: rgba(100, 116, 139, 0.65) transparent;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(148, 163, 184, 0.35);\n  border: 3px solid transparent;\n  border-radius: 999px;\n  background-clip: padding-box;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background-color: rgba(100, 116, 139, 0.6);\n}\n\n.custom-scrollbar::-webkit-scrollbar-corner {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
